import React, { useState } from 'react';
import { RadioGroup } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

interface Choice {
  id: string;
  name: string;
  description: string;
}

const choices: Choice[] = [
  {
    id: 'new',
    name: "No - I'm New to Skin Clique.",
    description: "We'll help you find a provider in your area and walk you through creating an account.",
  },
  {
    id: 'existing',
    name: "Yes - I'm an Existing Skin Clique Patient",
    description: 'Sign in to your account to schedule a new appointment.',
  },
];

const NewOrExistingCustomerScreen: React.FC = () => {
  const navigate = useNavigate();
  const [selectedChoice, setSelectedChoice] = useState<Choice | null>(null);

  const onSelectionMade = (choice: Choice) => {
    setSelectedChoice(choice);
    setTimeout(() => {
      if (choice.id === 'new') {
        navigate('/enter-zipcode');
      } else {
        window.location.href = 'https://book.skinclique.com/webstoreNew/user/signIn';
      }
    }, 300);
  };

  return (
    <Container>
      <Heading2>Do You Already Have a Skin Clique Provider?</Heading2>

      <fieldset>
        <RadioGroup
          value={selectedChoice}
          onChange={onSelectionMade}
          className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-1 lg:grid-cols-2 lg:gap-6"
        >
          {choices.map((choice) => (
            <RadioGroup.Option
              key={choice.id}
              value={choice}
              aria-label={choice.description}
              className="group relative flex cursor-pointer rounded-lg border border-grey-100 bg-white p-4 shadow-sm focus:outline-none"
            >
              <span className="flex flex-1">
                <span className="flex flex-col">
                  <span className="block text-lg font-bold font-large text-gray-900">{choice.name}</span>
                  <span className="mt-1 flex items-center text-sm text-gray-500">{choice.description}</span>
                </span>
              </span>
              <CheckCircleIcon
                aria-hidden="true"
                className={`h-5 w-5 text-deep-blue ${selectedChoice?.id === choice.id ? '' : 'invisible'}`}
              />
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -inset-px rounded-lg border-2 border-transparent group-data-[focus]:border group-data-[checked]:border-deep-blue"
              />
            </RadioGroup.Option>
          ))}
        </RadioGroup>
      </fieldset>
    </Container>
  );
};

export default NewOrExistingCustomerScreen;
